/**
 * Brand & legal identifiers for Selena Service site content.
 */
/** Canonical origin (no trailing slash) — SEO, canonical URLs, sitemap. */
export const SITE_ORIGIN_CANONICAL = "https://www.selenaservice.ro";

/** Origin for runtime absolute URLs (JSON-LD, previews); stays on localhost/staging host when testing. */
export function getSiteOriginRuntime() {
  if (typeof window === "undefined" || !window.location?.origin) {
    return SITE_ORIGIN_CANONICAL;
  }
  return window.location.origin;
}

/** Trade name (hero, logos alt text, SEO titles in App). */
export const SITE_BRAND_DISPLAY_NAME = "Selena Service Auto";

/** Official company name — GDPR operator / Terms & Conditions. */
export const SITE_LEGAL_ENTITY_NAME = "Selena Business Group SRL";
